/** Lossless transport only. No KPI arithmetic or quality filtering. */
export function unpackPerformanceWire<T>(payload: T): T {
  const wire = payload as { wireFormat?: string; entries?: unknown[]; root?: unknown };
  if (wire?.wireFormat !== "alta-dictionary-v1") return payload;
  if (!Array.isArray(wire.entries)) throw new Error("Invalid snapshot transport");
  const entries = wire.entries;
  function decode(node: unknown, ceiling: number): unknown {
    if (Array.isArray(node)) return node.map(value => decode(value, ceiling));
    if (node !== null && typeof node === "object") {
      const object = node as Record<string, unknown>;
      if ("$alta_perf_ref" in object) {
        const index = object.$alta_perf_ref;
        if (typeof index !== "number" || !Number.isInteger(index) || index < 0 || index >= ceiling)
          throw new Error("Invalid snapshot transport reference");
        return decode(entries[index], index);
      }
      return Object.fromEntries(Object.entries(object).map(([key, value]) => [key, decode(value, ceiling)]));
    }
    return node;
  }
  return decode(wire.root, entries.length) as T;
}
